// The sidebar sits on the brand gradient, so every value here reads against a dark blue.
export const sideBarColors = {
  background: "transparent",
  inactiveItem: "#ffffff",
  activeItem: "#ffffff",
  selectedBackground: "rgba(255, 255, 255, 0.12)",
  userCircle: "rgba(255, 255, 255, 0.16)",
  disconnectCircle: "rgba(255, 255, 255, 0.16)",
  bottomBackground: "transparent",
  bottomSeparator: "rgba(255, 255, 255, 0.16)",
  verticalLine: "rgba(255, 255, 255, 0.16)",
  name: "#ffffff",
  profile: "rgba(255, 255, 255, 0.7)",
  toolTipBackground: "#ffffff",
  toolTipText: "#0b293e",
};
